import { composeUnionMembers } from '../../union-roster/domain/composeUnionMembers.js';

export function buildRaidPracticeAdminMembers({
  rosterMembers = [],
  fallbackMembers = [],
  practiceRecords = [],
  actualRecords = [],
} = {}) {
  return composeUnionMembers({
    rosterMembers,
    fallbackMembers,
    records: [
      ...(Array.isArray(practiceRecords) ? practiceRecords : []),
      ...(Array.isArray(actualRecords) ? actualRecords : []),
    ],
    maxMembers: 64,
  });
}
